import { Component, OnInit, NgZone } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as $ from "jquery";
import { CstemapiService } from 'src/app/cstemapi.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth.service';

@Component({
  selector: 'app-sunhours',
  templateUrl: './sunhours.component.html',
  styleUrls: ['./sunhours.component.scss']
})
export class SunhoursComponent implements OnInit {
  chart1: any;
  sunHours: any;

  constructor(private cstemapi: CstemapiService, private myRoute: Router, private auth: AuthService) { }

  ngOnInit() {
    this.getSolarAngle();
  }

  ngAfterViewInit() {
    am4core.useTheme(am4themes_animated);
    // this.zone.runOutsideAngular(() => {

    if (this.chart1 != undefined) {
      this.chart1.dispose();
      this.chart1 = null;
    }

    this.chart1 = am4core.create("resourceChart1", am4charts.XYChart);

    var data = [];
    var open = 100;
    var close = 120;

    var names = [];

    var d, monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    for (var i = 1; i <= 12; i++) {
      d = this.daysInMonth(i, 2019);
      for (var j = 1; j <= d; j++) {
        names.push(monthName[i - 1] + ' ' + j)
      }
    }

    if (names.length == 365) {
      for (var i = 0; i < names.length; i++) {
        open += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 5);
        close = open + Math.round(Math.random() * 10) + 3;
        data.push({ category: names[i], open: open, close: close, sunrise: '6:30 AM', sunset: '5:30 PM' });
      }
      // console.log(data)
    }

    // var names = ["Raina",
    //   "Demarcus",
    //   "Carlo",
    //   "Jacinda",
    //   "Richie",
    //   "Antony",
    //   "Amada",
    //   "Idalia",
    //   "Janella",
    //   "Marla",
    //   "Curtis",
    //   "Shellie",
    //   "Meggan",
    //   "Nathanael",
    //   "Jannette",
    //   "Tyrell",
    //   "Sheena",
    //   "Maranda",
    //   "Briana",
    //   "Rosa",
    //   "Rosanne",
    //   "Herman",
    //   "Wayne",
    //   "Shamika",
    //   "Suk",
    //   "Clair",
    //   "Olivia",
    //   "Hans",
    //   "Glennie",
    // ];

    // for (var i = 0; i < names.length; i++) {
    //   open += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 5);
    //   close = open + Math.round(Math.random() * 10) + 3;
    //   data.push({ category: names[i], open: open, close: close });
    // }

    this.chart1.data = data;

    var categoryAxis = this.chart1.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.ticks.template.disabled = true;
    categoryAxis.renderer.axisFills.template.disabled = true;
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.minGridDistance = 15;
    categoryAxis.renderer.inversed = true;
    categoryAxis.renderer.inside = true;
    categoryAxis.renderer.grid.template.location = 0.5;
    categoryAxis.renderer.grid.template.strokeDasharray = "1,3";

    var valueAxis = this.chart1.xAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.ticks.template.disabled = true;
    valueAxis.renderer.axisFills.template.disabled = true;

    var series = this.chart1.series.push(new am4charts.ColumnSeries());
    series.dataFields.categoryY = "category";
    series.dataFields.openValueX = "open";
    series.dataFields.valueX = "close";
    series.tooltipText = "Sunrise: {openValueX.value} Sunset: {valueX.value}";
    series.sequencedInterpolation = true;
    series.fillOpacity = 0;
    series.strokeOpacity = 1;
    series.columns.template.height = 0.01;
    series.tooltip.pointerOrientation = "vertical";

    var openBullet = series.bullets.create(am4charts.CircleBullet);
    openBullet.locationX = 1;

    var closeBullet = series.bullets.create(am4charts.CircleBullet);

    closeBullet.fill = this.chart1.colors.getIndex(4);
    closeBullet.stroke = closeBullet.fill;

    this.chart1.cursor = new am4charts.XYCursor();
    this.chart1.cursor.behavior = "zoomY";

    this.chart1.scrollbarX = new am4core.Scrollbar();
    this.chart1.scrollbarY = new am4core.Scrollbar();

    // });
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  getSolarAngle() {
    var dObj = {
      userId: this.auth.getUserId(),
      lat: this.auth.getUserLocation().lat,
      lon: this.auth.getUserLocation().long
    };

    this.cstemapi.cstemAPI(dObj).GetSolarAngle.subscribe(data => {
      // console.log(data)
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.sunHours = resData;
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting Solar Angles!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }
}
